import React, {useEffect} from 'react';
import { Image, Text, Flex, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, ModalCloseButton } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toggleOrderDetailModal, getOrderDetail } from "../../actions/orderActions";
import { Spinner } from "@chakra-ui/spinner";

const Items = ({ orderId }) => {
    const dispatch = useDispatch();
    const items = useSelector((state) => state.orderDetails.orderItems);
    const loading = useSelector((state) => state.orderDetails.loading);

    useEffect(() => {
        dispatch(getOrderDetail(orderId));
    }, []);

    if (loading) return <Spinner />

    if (!items || !items.map) return <Text>No hay productos</Text>

    return (
        <Flex flexDir='row' mt='1em' mb='2em' flexWrap='wrap' maxW='100%' justifyContent='flex-start'
            overflowY='auto' maxH='300px'
        >
            {items.map((item) => (
                <Flex key={item._id} alignItems='center'>
                    <Flex flexDir='column' mr="2em">
                        <Image src={item.product.images[0]} alt={item.product.name} boxSize='100px' objectFit='cover' />
                        <Text mr='2em' fontSize="sm">{item.product.name}</Text>
                        <Text fontSize="xs">{item.qty} x ${item.product.price}</Text>
                    </Flex>
                </Flex>
            ))}
        </Flex>
    )
}

export default function OrderDetailModal(){
    const dispatch = useDispatch();
    const showModal = useSelector((state) => state.orderDetails.showOrderDetailModal);
    const order = useSelector((state) => state.orderDetails.order);
    const closeModal = () => {
        dispatch(toggleOrderDetailModal());
    };
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
    }

    if(!showModal) return null;

    return (
        <Modal isOpen={showModal} onClose={() => closeModal()} size="xl">
            <ModalOverlay />
            <ModalContent overflowY="auto">
                <ModalHeader>Detalles del Pedido</ModalHeader>
                <ModalCloseButton />
                <ModalBody> 
                    <Flex flexDir='column' mb='1em'>
                        <Text>Cliente: {order.customerName ?? 'N/A'}</Text>
                        <Text>Email: {order.customerEmail ?? 'N/A'}</Text>
                        <Text>Tel: {order.customerPhone ?? 'N/A'}</Text>
                        <Text>Fecha: {formatDate(order.createdAt) ?? 'N/A'}</Text>
                        <Text>Total: ${order.total}</Text>
                    </Flex>
                    <Text>Productos</Text>
                    <Items orderId={order._id} />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

